/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Module_Settings_Status_Last_CommunicationInputs */



/**
* | output |
* | --- |
* | "Last communication {date}" |
*
* @param {Module_Settings_Status_Last_CommunicationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_last_communication = /** @type {((inputs: Module_Settings_Status_Last_CommunicationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_Last_CommunicationInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Last communication ${i?.date}`)
	return /** @type {LocalizedString} */ (`Dernière communication ${i?.date}`)
});